const getAnimalLocation = ({animal_location_city, animal_location_area, animal_location_road, animal_location_details}) => {
    return `${animal_location_city}${animal_location_area}${animal_location_road}${animal_location_details}`;
};

export default getAnimalLocation;